module.exports = __webpack_public_path__ + "media/assets/images/solutions/process_automation/hero_image-cd615d4734dd338e36de2b56288356c0.png";